import React from "react";
import CrearAventura from "./crearaventura/diseno-crear-aventura";
import FooterMenu from './componenteshome/footer';
import MenuEscritorio from './componenteshome/MenuEscritorio';

export default function Crearaventura(){
    return <div><CrearAventura/><FooterMenu/><MenuEscritorio/></div>
}
